import { combineReducers } from 'redux';
import queryParams from './queryParamsInnerReducer';
import { WORKLIST } from '../worklist/worklistActionTypes';

const queryParamsCombined = combineReducers({
  worklist: queryParams(WORKLIST)
});

export default queryParamsCombined;
